export * from './line-chart.module';
export * from './line-chart.component';
export * from './line.component';
export * from './line-series.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/line-chart/index.js
// module id = ../../../../@swimlane/ngx-charts/release/line-chart/index.js
// module chunks = 4